<!-- <div class="absolute top-6 left-6 z-20">
  <h1 class="text-3xl font-bold text-[#4e54c8] select-none flex items-center">
    Clinic Suit
    <span class="relative">e
      <span class="absolute -top-1 -right-2 text-[#4e54c8] text-md">+</span>
    </span>
  </h1>
</div> -->
<div class="min-h-screen grid lg:grid-cols-2 bg-white">

  <!-- ============================
       ✅ LEFT SIDE — NOW LOGIN FORM
       ============================ -->
  <div class="flex items-center justify-center p-6 sm:p-10">

    <div class="w-full max-w-sm bg-white/70 backdrop-blur-xl shadow-2xl rounded-2xl p-6 sm:p-8 animate-fade-in">

      <!-- Logo -->
      <div class="text-center mb-6">
        <h1 class="text-3xl font-bold text-[#4e54c8] select-none flex justify-center items-center">
          Clinic Suit
          <span class="relative">e
            <span class="absolute -top-1 -right-2 text-[#4e54c8] text-lg">+</span>
          </span>
        </h1>

        <p class="text-gray-500 text-sm mt-1 tracking-wide">
          Smarter • Faster • More Connected
        </p>
      </div>

      <!-- Sign In Title -->
      <h2 class="text-xl font-semibold text-gray-700 mb-4 text-center">
        Sign In
      </h2>

      <!-- ✅ Login Form -->
      <form novalidate #form="ngForm" (submit)="OnSubmit(form)">

        <!-- Username -->
        <div class="mb-4">
          <input type="text" name="UserName" required [(ngModel)]="formModel.UserName" #userName="ngModel"
            placeholder="Username" [class]="'w-full px-4 py-2.5 border rounded-lg outline-none transition text-sm focus:ring-2 focus:ring-[#4e54c8] ' + 
              (formSubmitted && formModel.UserName == '' ? 'border-red-500' : 'border-gray-300')" />
        </div>

        <!-- Password -->
        <div class="mb-4 relative">
          <input [type]="isPasswordVisible ? 'text' : 'password'" name="Password" required
            [(ngModel)]="formModel.Password" placeholder="Password" [class]="'w-full px-4 py-2.5 border rounded-lg outline-none transition text-sm focus:ring-2 focus:ring-[#4e54c8] ' + 
              (formSubmitted && formModel.Password == '' ? 'border-red-500' : 'border-gray-300')" />

          <span (click)="isPasswordVisible = !isPasswordVisible"
            class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 cursor-pointer">
            <i [class]="isPasswordVisible ? 'ki-filled ki-eye-slash' : 'ki-filled ki-eye'"></i>
          </span>
        </div>

        <!-- Forgot Password -->
        <div class="flex justify-end mb-5">
          <label [routerLink]="'/forgot-password'" class="text-xs text-[#4e54c8] hover:underline cursor-pointer">
            Forgot password?
          </label>
        </div>

        <!-- Login Button -->
        @if (!loading) {
        <button type="submit" class="w-full py-2.5 bg-gradient-to-r from-[#4e54c8] to-[#8f94fb] 
                 text-white rounded-lg font-semibold shadow-md hover:opacity-90 transition">
          Sign In
        </button>
        } @else {
        <app-spinner [loading]="true"></app-spinner>
        }

        <!-- Links -->
        <div class="flex justify-center gap-6 mt-5 text-sm font-medium">
          <a href="assets/faqpage/faqpage.html" target="_blank" class="text-[#4e54c8] hover:underline">
            FAQs
          </a>
          <a href="assets/TutorialVideos/videos.html" target="_blank" class="text-[#4e54c8] hover:underline">
            How-To Videos
          </a>
        </div>

      </form>

    </div>
  </div>

  <!-- ============================
       ✅ RIGHT SIDE — ART + BRANDING
       ============================ -->
  <div class="relative hidden lg:flex items-center justify-center overflow-hidden">

    <!-- Gradient Background -->
    <div class="absolute inset-0 bg-gradient-to-br from-[#4e54c8] to-[#8f94fb]"></div>

    <!-- Soft Glow Circles -->
    <div class="absolute -top-20 -left-20 w-72 h-72 bg-white/20 rounded-full blur-3xl"></div>
    <div class="absolute bottom-10 right-10 w-80 h-80 bg-[#8f94fb]/20 rounded-full blur-2xl"></div>

    <!-- Main Content -->
    <div class="relative z-10 text-center text-white px-10 fade-in-right">
      <h1 class="text-4xl font-extrabold tracking-wide leading-tight drop-shadow-md">
        Welcome to <span class="text-white">Clinic Suite+</span>
      </h1>

      <p class="text-lg opacity-90 mt-4 max-w-md mx-auto leading-relaxed">
        Streamline your healthcare management with Clinic Suite+, the all-in-one solution designed to enhance patient
        care and optimize operations.
      </p>

      <img src="assets/media/misc/auth-screens.png" class="mx-auto mt-10 drop-shadow-2xl animate-fade-up" />
    </div>

  </div>

</div>